module.exports = __webpack_public_path__ + "static/media/banner.9a228e52.png";